import React, { useEffect, useState } from 'react';
import moment from 'moment';
import useFilter from '../hooks/useFilter';
import { Col, Row } from 'reactstrap';

export default function DateRange(options = {}) {
    const {
        title = 'Date Range',
        startFieldName = 'startDate',
        endFieldName = 'endDate',
        initialHelpText = '',
        defaultStartDate = moment().startOf('year').format('YYYY-MM-DD'),
        defaultEndDate = moment().format('YYYY-MM-DD'),
        filterStartKey = 'startDate',
        filterEndKey = 'endDate'
    } = options;

    const { filter } = useFilter();
    const [loading, setLoading] = useState(true);
    const [startDate, setStartDate] = useState(defaultStartDate);
    const [endDate, setEndDate] = useState(defaultEndDate);
    const [helpText, setHelpText] = useState(initialHelpText);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        let initialStart = defaultStartDate;
        let initialEnd = defaultEndDate;

        if (filter?.[filterStartKey]) {
            initialStart = filter[filterStartKey];
        }
        if (filter?.[filterEndKey]) {
            initialEnd = filter[filterEndKey];
        }

        setStartDate(initialStart);
        setEndDate(initialEnd);
        setHelpText(initialHelpText);
        validateDates(initialStart, initialEnd);
        setLoading(false);
        // We intentionally only run this once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const validateDates = (start, end) => {
        const startMoment = moment(start, 'YYYY-MM-DD', true);
        const endMoment = moment(end, 'YYYY-MM-DD', true);

        if (!startMoment.isValid()) {
            setErrorMessage("Start date is invalid.");
            return false;
        }
        if (!endMoment.isValid()) {
            setErrorMessage("End date is invalid.");
            return false;
        }
        if (startMoment.isAfter(endMoment)) {
            setErrorMessage("Start date must be before End date.");
            return false;
        }

        setErrorMessage("");
        return true;
    };

    const onStartChangeDate = (e) => {
        const newStart = e.target.value;
        setStartDate(newStart);
        validateDates(newStart, endDate);
    };

    const onEndChangeDate = (e) => {
        const newEnd = e.target.value;
        setEndDate(newEnd);
        validateDates(startDate, newEnd);
    };

    return ({
        loading, startDate, endDate, setHelpText,
        render:
            <Row>
                <Col xs="6">
                    <h5>{title}</h5>
                    {helpText}
                </Col>
                <Col xs="6">
                    <div>
                        <label>From</label>
                        <input className='dateRange-margin' name={startFieldName} type='date' value={startDate} onChange={onStartChangeDate} min='1900-01-01'
                            aria-invalid={!!errorMessage} aria-describedby='date-range-error'
                        />
                        <label>To</label>
                        <input
                            className='dateRange-margin' name={endFieldName} type='date' value={endDate} onChange={onEndChangeDate} min='1900-01-01'
                            aria-invalid={!!errorMessage} aria-describedby='date-range-error'
                        />
                        {errorMessage && (
                            <div id='date-range-error' className='text-danger'>
                                {errorMessage}
                            </div>
                        )}
                    </div>
                </Col>
            </Row>
    }
    );
}